import { config } from '@consigli/hooks';
import { createOAuthConfiguration } from '@consigli/oauth';

// Create auth config lazily at runtime (not at import time)
// This ensures isPdeEnvironment() can check window.location
let _authConfig: ReturnType<typeof createOAuthConfiguration> | null = null;

export const getAuthConfig = () => {
  if (!_authConfig) {
    _authConfig = createOAuthConfiguration({
      webappClientId: config.WEBAPP_CLIENT_ID,
      webappUrl: config.WEBAPP_URL,
      oauthEndpoint: config.OAUTH_ENDPOINT,
      redirectUri: import.meta.env.VITE_OAUTH_REDIRECT_URI,
    });
  }
  return _authConfig;
};

// For backwards compatibility
export const authConfig = getAuthConfig();
